var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1312,
    height: 847,
    viewBox: "0 0 1312 847",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1312,
    height: 738,
    rx: 15,
    fill: "url(#paint0_linear_86_8939)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.139 551.028C169.876 601.854 63.3588 681.192 2.9817 738.768L1.98774 737.127C62.4941 679.427 169.172 599.974 292.626 549.07C416.072 498.169 556.392 475.773 684.114 532.366C938.883 645.253 1208.08 607.551 1310.78 574.601L1311.19 576.598C1208.26 609.618 938.725 647.369 683.567 534.31C556.324 477.929 416.408 500.2 293.139 551.028Z",
    fill: "#DFEFF9",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.139 587.106C169.876 637.931 63.3588 717.269 2.9817 774.845L1.98774 773.204C62.4941 715.505 169.172 636.051 292.626 585.147C416.072 534.246 556.392 511.85 684.114 568.443C938.883 681.33 1208.08 643.628 1310.78 610.678L1311.19 612.676C1208.26 645.696 938.725 683.446 683.567 570.387C556.324 514.006 416.408 536.277 293.139 587.106Z",
    fill: "#DFEFF9",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.139 623.183C169.876 674.008 63.3588 753.347 2.9817 810.923L1.98774 809.281C62.4941 751.582 169.172 672.129 292.626 621.224C416.072 570.323 556.392 547.928 684.114 604.52C938.883 717.408 1208.08 679.705 1310.78 646.756L1311.19 648.753C1208.26 681.773 938.725 719.524 683.567 606.464C556.324 550.083 416.408 572.355 293.139 623.183Z",
    fill: "#DFEFF9",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.139 659.26C169.876 710.086 63.3588 789.424 2.9817 847L1.98774 845.359C62.4941 787.659 169.172 708.206 292.626 657.302C416.072 606.401 556.392 584.005 684.114 640.598C938.883 753.485 1208.08 715.783 1310.78 682.833L1311.19 684.83C1208.26 717.85 938.725 755.601 683.567 642.541C556.324 586.161 416.408 608.432 293.139 659.26Z",
    fill: "#DFEFF9",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.267 536.056C170.053 586.862 63.5756 666.171 3.23081 723.717L1.73987 721.255C62.2785 663.524 168.997 584.042 292.498 533.119C415.988 482.199 556.41 459.772 684.251 516.418C938.924 629.262 1208.03 591.572 1310.68 558.64L1311.29 561.636C1208.31 594.674 938.686 632.436 683.43 519.334C556.307 463.006 416.493 485.246 293.267 536.056Z",
    fill: "#DFEFF9",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.395 520.054C170.229 570.839 63.7916 650.12 3.47913 707.635L1.4912 704.352C62.0622 646.591 168.82 567.08 292.37 516.136C415.904 465.199 556.427 442.741 684.387 499.44C938.963 612.241 1207.98 574.563 1310.58 541.648L1311.39 545.643C1208.36 578.698 938.646 616.473 683.294 503.327C556.29 447.053 416.577 469.262 293.395 520.054Z",
    fill: "#DFEFF9",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.523 504.051C170.405 554.817 64.0076 634.069 3.72744 691.553L1.24254 687.449C61.8458 629.657 168.644 550.118 292.241 499.154C415.82 448.199 556.444 425.709 684.524 482.461C939.003 595.22 1207.94 557.553 1310.47 524.656L1311.49 529.65C1208.4 562.723 938.606 600.51 683.157 487.321C556.272 431.099 416.661 453.277 293.523 504.051Z",
    fill: "#DFEFF9",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.651 481.863C170.581 532.61 64.2236 611.833 3.97575 669.286L0.993868 664.362C61.6295 606.539 168.468 526.971 292.113 475.988C415.736 425.014 556.461 402.493 684.661 459.298C939.042 572.013 1207.89 534.359 1310.37 501.48L1311.59 507.472C1208.45 540.562 938.566 578.361 683.02 465.13C556.255 408.961 416.744 431.108 293.651 481.863Z",
    fill: "#DFEFF9",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.78 455.552C170.757 506.279 64.4404 585.473 4.22487 642.895L0.746002 637.151C61.4139 579.297 168.293 499.7 291.985 448.697C415.652 397.705 556.479 375.154 684.798 432.011C939.082 544.684 1207.84 507.042 1310.27 474.18L1311.7 481.171C1208.5 514.279 938.527 552.09 682.883 438.815C556.239 382.699 416.829 404.815 293.78 455.552Z",
    fill: "#DFEFF9",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.908 419.965C170.933 470.671 64.6564 549.837 4.47318 607.229L0.497335 600.663C61.1976 542.779 168.116 463.153 291.857 412.13C415.568 361.12 556.496 338.537 684.935 395.448C939.122 508.077 1207.8 470.448 1310.17 437.603L1311.8 445.593C1208.55 478.718 938.487 516.541 682.747 403.224C556.221 347.161 416.913 369.246 293.908 419.965Z",
    fill: "#DFEFF9",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.164 387.959C171.285 438.626 65.0884 517.735 4.96981 575.064L0 566.857C60.7649 508.911 167.764 429.228 291.6 378.166C415.4 327.12 556.53 304.475 685.208 361.491C939.201 474.035 1207.7 436.429 1309.97 403.62L1312 413.606C1208.64 446.767 938.408 484.615 682.473 371.211C556.187 315.254 417.081 337.276 294.164 387.959Z",
    fill: "#DFEFF9",
    fillOpacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.139 223.028C169.876 273.854 63.3588 353.192 2.9817 410.768L1.98774 409.127C62.4941 351.427 169.172 271.974 292.626 221.07C416.072 170.169 556.392 147.773 684.114 204.366C938.883 317.253 1208.08 279.551 1310.78 246.601L1311.19 248.598C1208.26 281.618 938.725 319.369 683.567 206.31C556.324 149.929 416.408 172.2 293.139 223.028Z",
    fill: "#DFEFF9",
    fillOpacity: 0.19
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.139 259.106C169.876 309.931 63.3588 389.269 2.9817 446.845L1.98774 445.204C62.4941 387.505 169.172 308.051 292.626 257.147C416.072 206.246 556.392 183.85 684.114 240.443C938.883 353.33 1208.08 315.628 1310.78 282.678L1311.19 284.676C1208.26 317.696 938.725 355.446 683.567 242.387C556.324 186.006 416.408 208.277 293.139 259.106Z",
    fill: "#DFEFF9",
    fillOpacity: 0.19
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.139 295.183C169.876 346.008 63.3588 425.347 2.9817 482.923L1.98774 481.281C62.4941 423.582 169.172 344.129 292.626 293.224C416.072 242.323 556.392 219.928 684.114 276.52C938.883 389.408 1208.08 351.705 1310.78 318.756L1311.19 320.753C1208.26 353.773 938.725 391.524 683.567 278.464C556.324 222.083 416.408 244.355 293.139 295.183Z",
    fill: "#DFEFF9",
    fillOpacity: 0.19
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.139 331.26C169.876 382.086 63.3588 461.424 2.9817 519L1.98774 517.359C62.4941 459.659 169.172 380.206 292.626 329.302C416.072 278.401 556.392 256.005 684.114 312.598C938.883 425.485 1208.08 387.783 1310.78 354.833L1311.19 356.83C1208.26 389.85 938.725 427.601 683.567 314.541C556.324 258.161 416.408 280.432 293.139 331.26Z",
    fill: "#DFEFF9",
    fillOpacity: 0.19
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.267 208.056C170.053 258.862 63.5756 338.171 3.23081 395.717L1.73987 393.255C62.2785 335.524 168.997 256.042 292.498 205.119C415.988 154.199 556.41 131.772 684.251 188.418C938.924 301.262 1208.03 263.572 1310.68 230.64L1311.29 233.636C1208.31 266.674 938.686 304.436 683.43 191.334C556.307 135.006 416.493 157.246 293.267 208.056Z",
    fill: "#DFEFF9",
    fillOpacity: 0.19
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.395 192.054C170.229 242.839 63.7916 322.12 3.47913 379.635L1.4912 376.352C62.0622 318.591 168.82 239.08 292.37 188.136C415.904 137.199 556.427 114.741 684.387 171.44C938.963 284.241 1207.98 246.563 1310.58 213.648L1311.39 217.643C1208.36 250.698 938.646 288.473 683.294 175.327C556.29 119.053 416.577 141.262 293.395 192.054Z",
    fill: "#DFEFF9",
    fillOpacity: 0.19
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.523 176.051C170.405 226.817 64.0076 306.069 3.72744 363.553L1.24254 359.449C61.8458 301.657 168.644 222.118 292.241 171.154C415.82 120.199 556.444 97.7095 684.524 154.461C939.003 267.22 1207.94 229.553 1310.47 196.656L1311.49 201.65C1208.4 234.723 938.606 272.51 683.157 159.321C556.272 103.099 416.661 125.277 293.523 176.051Z",
    fill: "#DFEFF9",
    fillOpacity: 0.19
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.651 153.863C170.581 204.61 64.2236 283.833 3.97575 341.286L0.993868 336.362C61.6295 278.539 168.468 198.971 292.113 147.988C415.736 97.0138 556.461 74.4934 684.661 131.298C939.042 244.013 1207.89 206.359 1310.37 173.48L1311.59 179.472C1208.45 212.562 938.566 250.361 683.02 137.13C556.255 80.9611 416.744 103.108 293.651 153.863Z",
    fill: "#DFEFF9",
    fillOpacity: 0.19
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.78 127.552C170.757 178.279 64.4404 257.473 4.22487 314.895L0.746002 309.151C61.4139 251.297 168.293 171.7 291.985 120.697C415.652 69.7052 556.479 47.1537 684.798 104.011C939.082 216.684 1207.84 179.042 1310.27 146.18L1311.7 153.171C1208.5 186.279 938.527 224.09 682.883 110.815C556.239 54.6993 416.829 76.8149 293.78 127.552Z",
    fill: "#DFEFF9",
    fillOpacity: 0.19
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.908 91.9646C170.933 142.671 64.6564 221.837 4.47318 279.229L0.497335 272.663C61.1976 214.779 168.116 135.153 291.857 84.1304C415.568 33.1201 556.496 10.5374 684.935 67.4481C939.122 180.077 1207.8 142.448 1310.17 109.603L1311.8 117.593C1208.55 150.718 938.487 188.541 682.747 75.2238C556.221 19.161 416.913 41.2455 293.908 91.9646Z",
    fill: "#DFEFF9",
    fillOpacity: 0.19
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.164 59.959C171.285 110.626 65.0884 189.735 4.96981 247.064L0 238.857C60.7649 180.911 167.764 101.228 291.6 50.1663C415.4 -0.880482 556.53 -23.5254 685.208 33.4912C939.201 146.035 1207.7 108.429 1309.97 75.6198L1312 85.6064C1208.64 118.767 938.408 156.615 682.473 43.2109C556.187 -12.7459 417.081 9.27632 294.164 59.959Z",
    fill: "#DFEFF9",
    fillOpacity: 0.19
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_8939",
    x1: 656,
    y1: 0,
    x2: 656,
    y2: 738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE0459",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.d2c15ef9b3c685c37f28b6a9eb9b1e4c.svg";
export { ForwardRef as ReactComponent };